import { useDataChange } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let change = useDataChange({
    context: 'event_action',
    viewPath: props.viewPath,
    path: 'data',
  })

  return function onChange(next, ...args) {
    if (!next) return
    // sync up flag values.
    let skip_flags = next.map(({ flag, value }) => ({ flag, value }))
    change(next => {
      next.data = { ...next.data, skip_flags }
    })
  }
}
